// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fixed[data-v-8da46052] {\n  right: 72px;\n  bottom: 42px;\n  position: fixed;\n  z-index: 99;\n  opacity: 0.85;\n  box-shadow: 0px 8px 16px rgba(62, 62, 60, 0.24);\n}\n.red--circle[data-v-8da46052] {\n  border-radius: 50%;\n  background-color: red;\n  width: 8px;\n  height: 8px;\n}\n@media only screen and (max-width: 600px) {\n.fixed[data-v-8da46052] {\n    right: 24px;\n    bottom: 24px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
